import { useState } from "react";
import { LocaleFlag, SettingsGearIcon } from "./LocaleIcons.js";
import { useLocale } from "./useLocale.js";
import { LocaleSettingsModal } from "./LocaleSettingsModal.js";

function formatPreferencesSummary(preferences, display) {
  const language = preferences.locale === "en"
    ? display.t("web.settings.languageEn")
    : display.t("web.settings.languageNl");
  const units = preferences.unitSystem === "imperial"
    ? display.t("web.settings.unitsImperial")
    : display.t("web.settings.unitsMetric");

  return display.t("web.settings.currentSummary", { language, units });
}

export function SettingsMenuButton() {
  const { display, preferences } = useLocale();
  const [open, setOpen] = useState(false);
  const summary = formatPreferencesSummary(preferences, display);

  return (
    <>
      <button
        type="button"
        className="ghost-button settings-menu-button has-tooltip"
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={display.t("web.settings.menuA11y", { summary })}
        onClick={() => setOpen(true)}
      >
        <LocaleFlag locale={preferences.locale} />
        <SettingsGearIcon className="settings-menu-icon" />
        <span className="icon-button-tooltip">{summary}</span>
      </button>
      {open && <LocaleSettingsModal onClose={() => setOpen(false)} />}
    </>
  );
}
